import { render, staticRenderFns } from "./viewActivityDetail.vue?vue&type=template&id=18b1f0e7&"
import script from "./viewActivityDetail.vue?vue&type=script&lang=js&"
export * from "./viewActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports